export const DROPDOWN_DIRECTION = {
  LEFT: "left",
  RIGHT: "right",
};
